<template>
  <ux-form
    ref="form"
    :data="formData"
    width="300px"
    :colon="true"
    :rules="rules"
    data-automation="addGroup"
  >
    <ux-form-item :label="$t('HT.router.userListGroup')" prop="group_ids">
      <ux-select v-model="formData.group_ids" clearable :options="options"></ux-select>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          group_ids: '' //用户组
        };
      }
    }
  },
  data() {
    return {
      options: [],
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.register(this)
    };
  },
  created() {
    this.getGroup();
  },
  methods: {
    /**
     * 获取用户组
     */
    getGroup() {
      this.$api.system.getGroup().then((res) => {
        if (res.code == 10000) {
          // 转换成用户组单选框所需要的格式
          let result = res.data.map((item) => {
            return {
              label: item.group_name,
              value: item.id
            };
          });
          this.options = result;
        }
      });
    }
  }
};
</script>
